import { useCallback } from 'react';
import globalFilterService, { type FilterEncodeData } from '@/core/services/GlobalFilterService';

export function useFilterDecode() {
  const decodeFilter = useCallback(async (filterId: string): Promise<FilterEncodeData | undefined> => {
    try {
      const response = await globalFilterService.decode(filterId);
      return response.data;
    } catch (e) {
      console.error('Failed to decode filter', e);
      return undefined;
    }
  }, []);

  return { decodeFilter };
}
